import React from 'react';
import useStyle from './avatar.style';
import { classNames } from '../../../helpers/style/classNames';
import DefaultAvatar from '../../../assets/avatar/avatar_default.webp';
import { getBorderVariantWithSource } from 'helpers/avatar/getBorderVariantWithSource';
export interface AvatarProps {
  source: string;
  variant: 'extrasmall' | 'small' | 'leaderboard' | 'large' | 'sidebar';
  alt: string;
}

export const Avatar = ({ source, variant, alt }: AvatarProps) => {
  const classes = useStyle();
  const borderVariant = getBorderVariantWithSource(source);

  return (
    <div
      className={classNames([
        classes.root,
        classes[variant],
        classes[borderVariant]
      ])}
    >
      <img
        alt={alt}
        src={source ? source : DefaultAvatar}
        className={classes.avatar}
      />
    </div>
  );
};
